import React, { useEffect, useState, useRef, useMemo, memo } from 'react';
import { Link, useNavigate } from "react-router-dom";
import images from '../../../services/images';
import ContentHeader from '../../parts/ContentHeader';
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import { postApiData, getApiData } from '../../../services/apiService';
import bentapro_logo from './img/BentaPro-Logo.png'
import bentapro_horizontal_logo from './img/BentaPro-Horizontal-Logo.png';
import './css/style.css'
import { useReactToPrint } from "react-to-print";
import { Dropdown } from "primereact/dropdown";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from 'primereact/inputtextarea';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
    FaRegFileExcel,
    FaTimesCircle
} from "react-icons/fa";
import { PiUserSwitchBold, PiTruckFill } from "react-icons/pi";

import {
    BsCashStack,
    BsPlayCircleFill,
    BsLockFill,
    BsPcDisplay,
    BsCurrencyDollar,
    BsCheckCircleFill,
    BsXCircle
} from "react-icons/bs";
import PosReceiptPrint from './PosReceiptPrint';
 
export default function POSPanel (){
    const PosSessionKeyName = 'PosSessionID';
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const menuRight = useRef(null);
    const toast = useRef(null);
    const [errors, setErrors] = useState([]);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [maximized, setMaximized] = useState(false);
    const [cart, setCart] = useState([]);
    const [amountReceived, setAmountReceived] = useState("");
    const [paymentMethodId, setPaymentMethodId] = useState(1);
    const [paymentReferenceNo, setPaymentReferenceNo] = useState("");
    const [menuAlignment, setMenuAlignment] = useState('right'); // Default desktop to right
    
    // const [isPosActive, setIsPosActive] = useState(false);
    const [showStartSession, setShowStartSession] = useState(false);
    const [openingCash, setOpeningCash] = useState(0);
    const [terminalId, setTerminalId] = useState(null);
    const [session, setSession] = useState(null);
    const [isPosActive, setIsPosActive] = useState(true);
    //const isPosActive = session?.status === "open";

    const [showCloseSession, setShowCloseSession] = useState(false);
    const [actualCash, setActualCash] = useState(0);

    const [showCustomer, setShowCustomer] = useState(false);
    const [customerData, setCustomerData] = useState({
        customer_id: 0,
        customer_name: ""
    });

    
    const [terminals, setTerminals] = useState([]);
    const [renderedProucts, setRenderedProducts] = useState(false);

    const searchRef = useRef(null);
    const [keyword, setKeyword] = useState("");
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(0);
    const [loadingProducts, setLoadingProducts] = useState(false);
    
    const [hasFeaturedProducts, setHasFeaturedProducts] = useState(false);

    const [showReceiptDialog, setShowReceiptDialog] = useState(false);
    const [receiptData, setReceiptData] = useState({});
    const receiptRef = useRef(null);

    const actionItems = [
        {
            label: 'Close Session',
            icon: <i className="fas fa-door-closed mr-2 text-danger"></i>,
            command: () => {
                setActualCash(0);
                setShowCloseSession(true);
            }
        },
        {
            label: 'Movement',
            icon: <i className="fas fa-exchange-alt mr-2 text-warning"></i>,
            command: () => {
                setMovement({
                    movement_type: "CASH_OUT",
                    amount: 0,
                    remarks: ""
                });
                setShowMovement(true);
            }
        }
    ];

    const paymentMethods = [ 
        { id: 1, method_name: "Cash" }, 
        { id: 2, method_name: "Credit/Debit Card" }, 
        { id: 3, method_name: "Bank Transfer" }, 
        { id: 4, method_name: "Check" }, 
        { id: 5, method_name: "QR Ph" }, 
        { id: 6, method_name: "GCash" }, 
        { id: 7, method_name: "Maya" }, 
        // { id: 8, method_name: "Invoice Payment" }, 
        //{ id: 9, method_name: "Split Payment" } 
    ];

    const [showMovement, setShowMovement] = useState(false);
    const [movement, setMovement] = useState({
        movement_type: "CASH_OUT",
        amount: 0,
        remarks: ""
    });
    const movementTypes = [
        {
            id: "CASH_IN",
            label: "Cash-In"
        },
        {
            id: "CASH_OUT",
            label: "Cash-Out"
        },
        {
            id: "EXPENSE",
            label: "Expense"
        }
    ];

    const handlePrint = useReactToPrint({
        contentRef: receiptRef,
        documentTitle: `Receipt-${receiptData.invoice_no}`
    });



    const summary = useMemo(() => {
        const totalItems = cart.reduce(
            (sum, item) => sum + item.quantity,
            0
        );

        const subtotal = cart.reduce(
            (sum, item) => sum + (item.quantity * item.product_price),
            0
        );

        const discount = 0;

        const tax = 0;

        const total = subtotal - discount + tax;

        return {
            totalItems,
            subtotal,
            discount,
            tax,
            total
        };

    }, [cart]);

    const stateRef = useRef({ cart, amountReceived, summary, paymentReferenceNo, paymentMethodId, customerData });

    useEffect(() => {
        initTreeView()
        //fetchTerminals()
        checkActiveSession()
    }, []);

    useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth < 768) {
            setMenuAlignment('left');  // Snaps left edge of menu to left edge of button
        } else {
            setMenuAlignment('right'); // Snaps right edge of menu to right edge of button
        }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        function getUniqueCategories(products) {
            const seen = new Map();
            
            products.forEach(product => {
                if (!seen.has(product.category_id)) {
                seen.set(product.category_id, {
                    category_id: product.category_id,
                    category_name: product.category_name
                });
                }
            });

            return Array.from(seen.values());
        }

        setCategories(getUniqueCategories(products));
    }, [products]);

    useEffect(() => {
        stateRef.current = { session, cart, amountReceived, summary, paymentMethodId, paymentReferenceNo, customerData };
    }, [cart, amountReceived, summary, paymentMethodId, session, paymentReferenceNo, customerData]);

    // 3. Keep your event listener bound safely exactly ONCE
    useEffect(() => {
        const handleKeyDown = (e) => {
            const isFunctionKey = /^F[1-9]$|^F10$/.test(e.key);

            if (isFunctionKey) {
            e.preventDefault(); 

            // Destructure live variables from the tracking reference pointer
            const { cart: liveCart, amountReceived: liveAmount, summary: liveSummary } = stateRef.current;

            switch (e.key) {
                case 'F1':
                if (searchRef.current) searchRef.current.focus();
                break;
                case 'F2':
                if (!liveCart.length) {
                    showNotif('Cart is empty. Please add an item before proceeding.', 'error', '', 5000);
                } else if (!liveAmount || liveAmount < liveSummary.total) {
                    showNotif('Enter cash amount received below.', 'error', '', 5000);
                } else {
                    handleSubmit(); 
                }
                break;
                case 'F4':
                showNotif('Cart cleared. Ready for next item.', 'success', '');
                setCart([]);
                setAmountReceived(0)
                
                break;
                default:
                break;
            }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []); // 👈 Keeps event subscription static and ultra-performant

    function checkActiveSession(){
        if (localStorage.getItem(PosSessionKeyName)) {
            fetchActiveSession(localStorage.getItem(PosSessionKeyName))
        }else{
            setIsPosActive(false)
            fetchTerminals()
        }

        //localStorage.setItem(PosSessionKeyName, '');
    }

    async function fetchActiveSession(id){
        setLoading(1)
        
        let endpoint = helpers.createPosUrl(`sessions/${id}`)
        
        const res = await getApiData(endpoint, false)
        if(res.status === 'error'){
            setLoading(0)
            fetchTerminals()
            setIsPosActive(false)
        }
        else{
            setSession(res)
            setIsPosActive(true)
            fetchTerminals()
        }
    }

    async function fetchTerminals(){
        setLoading(1)
        
        let endpoint = helpers.createPosUrl(`terminals?status=1`)
        
        const res = await getApiData(endpoint, false)
        if(res.status === 'error'){
            setLoading(0)
        }
        else{
            setLoading(0)
            setTerminals(res)
            searchFeaturedProduct()
        }
    }

    const startPosSession = async () => {
        if (!terminalId) {
            showNotif("Please select terminal.");
            return;
        }

        const payLoad = {
            terminal_id: terminalId,
            opening_cash: openingCash,
            status: "open"
        }
        setLoading(0)
        
        let endpoint = helpers.createPosUrl(`sessions`)
        
        const res = await postApiData(endpoint,payLoad, false)
        if(res.status === 'error'){
            setLoading(0)
            showNotif(res.message, 'error', '');
        }
        else{
            setLoading(0)
            setSession(res.data)
            setShowStartSession(false);
            setIsPosActive(true)
            localStorage.setItem(PosSessionKeyName, res.data?.id);
            resetForm()
            showNotif(res.message, 'success', '');
        }
    };

    const closePosSession = async () => {

        if (!actualCash || actualCash <= 0) {
            //showNotif("Please enter the actual cash count.");
            //return;
        }

        const payLoad = {
            session_id: session.id,
            terminal_id: session.terminal_id,
            actual_cash: actualCash,
            status: 'closed'
        };

        // TODO:
        let endpoint = helpers.createPosUrl(`sessions/${session.id}`)
        
        const res = await postApiData(endpoint,payLoad, false)
        if(res.status === 'error'){
            setLoading(0)
            showNotif(res.message, 'error', '');
            return
        }

        setSession(null);
        setIsPosActive(false)
        setShowCloseSession(false);
        localStorage.removeItem(PosSessionKeyName);
        setLoading(0)
        resetForm()
        setProducts([])
        setKeyword("")
        showNotif(res.message, 'success', '');
        setMaximized(false)
    };

    const saveMovement = async () => {
        if (!movement.amount || movement.amount <= 0) {
            showNotif("Amount is required.");
            return;
        }

        const payLoad = {
            pos_session_id: session.id,
            movement_type: movement.movement_type,
            amount: movement.amount,
            remarks: movement.remarks
        };

        //setShowMovement(false);
        let endpoint = helpers.createPosUrl(`sessions/${session.id}/movement`)
        
        const res = await postApiData(endpoint,payLoad, false)
        if(res.status === 'error'){
            setLoading(0)
            showNotif(res.message, 'error', '');
            return
        }
        
        setLoading(0)
        resetForm()
        showNotif(res.message, 'success', '');
        setShowMovement(false);
    };

    const resetForm = () => {
        setOpeningCash(0)
        setTerminalId(false)
        setActualCash(0)
        setCustomerData({
            customer_id: 0,
            customer_name: ""
        })
    }

    const addToCart = (product) => {
        const trackInventory = Number(product.track_inventory);
        const availableStock = Number(product.available_stock);

        if (trackInventory === 1 && availableStock < 1) {
            toast.current.show({
                severity: "warn",
                summary: "Out of Stock",
                detail: `${product.product_name} is currently out of stock.`,
                life: 3000
            });

            return;
        }

        const existingItem = cart.find(
            item => item.product_variant_id == product.product_variant_id
        );

        const nextQty = existingItem
            ? existingItem.quantity + 1
            : 1;
        
        if (nextQty > availableStock && trackInventory) {

            toast.current.show({
                severity: "warn",
                summary: "Insufficient Stock",
                detail: `Only ${product.available_stock} item(s) available.`,
                life: 3000
            });

            return;

        }

        if (existingItem) {

            setCart(prev =>
                prev.map(item =>
                    item.product_variant_id === product.product_variant_id
                        ? {
                            ...item,
                            quantity: nextQty
                        }
                        : item
                )
            );

        } else {

            setCart(prev => [
                ...prev,
                {
                    ...product,
                    quantity: 1
                }
            ]);

        }

        //searchRef.current?.focus();

    };

    const increaseQty = (productVariantId) => {

        setCart(prev =>

            prev.map(item => {

                if (item.product_variant_id != productVariantId) {
                    return item;
                }

                // Prevent exceeding available stock
                if (item.quantity >= item.available_stock) {

                    toast.current.show({
                        severity: "warn",
                        summary: "Insufficient Stock",
                        detail: `Only ${item.available_stock} item(s) available.`,
                        life: 3000
                    });

                    return item;

                }

                return {
                    ...item,
                    quantity: item.quantity + 1
                };

            })

        );

    };

    const decreaseQty = (productVariantId) => {

        setCart(prev =>

            prev.map(item => {

                if (item.product_variant_id != productVariantId) {
                    return item;
                }

                // Minimum quantity is 1
                if (item.quantity <= 1) {
                    return item;
                }

                return {
                    ...item,
                    quantity: item.quantity - 1
                };

            })

        );

    };

    const removeItem = (productVariantId) => {
        setCart(prev =>
            prev.filter(
                item => item.product_variant_id !== productVariantId
            )
        );
    };

    /**
     * SEARCH
     */
    const handleSearch = (e) => {

        const value = e.target.value;

        setKeyword(value);

        if(!value.trim().length){
            searchFeaturedProduct()
            return;
        }
        else if (value.trim().length < 2) {
            //setProducts([]);
            return;
        }

        searchProduct(value);

    };

    const handleKeyDown = (e) => {

        if (e.key !== "Enter") return;

        e.preventDefault();

        const value = keyword.trim();

        if (!value) return;

        //console.log('keydown value', value)

        // TODO:
        searchProduct(value);

    };

    const searchProduct = async (value) => {

        setLoadingProducts(true);

        let filter = `?store_id=${helpers.getStoreID()}&search=${value}&limit=20&paginate=0`;

        let endpoint =
            helpers.createUrl(`V1/manage/item/search${filter}`);

        const res = await getApiData(endpoint, false);

        if (res.status === "error") {

            setProducts([]);
            //setCategories([])
        } else {
            setProducts(Array.isArray(res) ? res : []);
            //setCategories(getUniqueCategories(res))
        }

        setLoadingProducts(false);

    };
    
    const searchFeaturedProduct = async () => {

        setLoadingProducts(true);

        let filter = `?store_id=${helpers.getStoreID()}&limit=20&paginate=0`;

        let endpoint = helpers.createUrl(`V1/manage/item/featured-product${filter}`);

        const res = await getApiData(endpoint, false);

        if (res.status === "error") {

            setProducts([]);
            //setCategories([]);
            setHasFeaturedProducts(false)
        } else {
            setProducts(Array.isArray(res) ? res : []);

            if(res.length > 0){
                setHasFeaturedProducts(true)
            }
            else{
                setHasFeaturedProducts(false)
            }
            //setCategories(getUniqueCategories(res))

        }

        setLoadingProducts(false);
        
    }

    const clearSearch = () => {
        setKeyword("");
        setProducts([])
        searchRef.current?.focus();
    };

    const selectedTerminal = useMemo(() => {
        return terminals.find(
            x => x.id === session?.terminal_id
        );

    }, [session, terminalId]);

    const showNotif = (message, type = 'warn', summary = "Validation", life = 5000) => {
        toast.current.show({
            severity: type,
            summary: summary,
            detail: message,
            life: life
        });
    };

    const subtotal = cart.reduce(
        (sum, item) => sum + (item.product_price * item.quantity),
        0
    );

    const discount = 0;
    const tax = 0;

    const total = subtotal - discount + tax;

    const change = Math.max(
        amountReceived - summary.total,
        0
    );
    const balance = Math.max(
        summary.total - amountReceived,
        0
    );

    const CurrencyInput = ({
        value,
        onValueChange,
        className = "",
        ...props
    }) => {
        return (
            <div className={`input-group ${className}`}>
                <div className="input-group-prepend">
                    <span className="input-group-text">
                        ₱
                    </span>
                </div>
                <InputNumber
                    value={value}
                    onValueChange={onValueChange}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    inputClassName="text-right"
                    className="flex-grow-1 input-currency"
                    {...props}
                />
            </div>
        );
    };

    function formatCartData(cartItems) {
        if (!Array.isArray(cartItems)) return [];

        return cartItems.map(item => ({
            product_id: item.id,
            product_variant_id: item.product_variant_id,
            quantity: item.quantity ?? 1,
            amount: item.product_price ? parseFloat(item.product_price) : 0, // Named as 'amount'
            unit_cost: item.product_cost ? parseFloat(item.product_cost) : 0,
            unit_name: item.unit_name,
            tax_rate_id: item.tax_rate_id,
            product_description: item.product_description,
            discount_rate_id: item.discount_rate_id,
            tax_name: item.tax_name ?? null,
            tax_rate: item.tax_rate ?? null,
            discount_rate: item.discount_rate ?? null,
            discount_type: item.discount_type ?? null,
        }));
    }

    const handleSubmit = async () => {
        const { cart: liveCart, paymentMethodId: livePaymentMethodID, session: liveSession, paymentReferenceNo : livePaymentReferenceNo, customerData: liveCustomer } = stateRef.current;

        //console.log('liveCustomer', liveCustomer.customer_name ? liveCustomer.customer_name : 'Walk-In' )
        const payLoad = {
               //"id": "",
                "store_id": helpers.getStoreID(),
                "invoice_date": new Date(),
                "due_date": new Date(),
                "source_type": "pos",
                "source_id": liveSession.id,
                "reference_no": livePaymentReferenceNo,
                "customer_id": liveCustomer.customer_id ? liveCustomer.customer_id : 0,
                "customer_name": liveCustomer.customer_name ? liveCustomer.customer_name : 'Walk-In',
                "shipping_contact_name": "Walk-In",
                "shipping_fee": 0,
                "payment_term_id": 1,
                "sales_channel_id": 1,
                "notes": "",
                "customer_notes": "Thank you for your purchase!",
                "status_id": 7,//Paid
                "payment_method_id": livePaymentMethodID,
                "items": formatCartData(liveCart)
        }
        
        let endpoint = helpers.createUrl('V1/manage/invoices/create')
        
        const res = await postApiData(endpoint, payLoad, false)
        if(res.status === 'error'){
            setLoading(0)
            showNotif(res.message, 'error', '');
            return
        }
        // else{
        //     setLoading(0)
        //     setPaymentMethodId(1)
        //     setAmountReceived(0)
        //     setCart([])
        //     clearSearch()
        //     showNotif('Payment received! Order is processed and ready for the next customer.', 'success', '');
        // }

        setReceiptData(res.data);
        setShowReceiptDialog(true);
    }

    const startNewSale = () => {
        setShowReceiptDialog(false);

        setPaymentMethodId(1);
        setAmountReceived(0);
        setCart([]);
        clearSearch();
        setReceiptData({})
        setCustomerData({
            customer_id: 0,
            customer_name: ""
        })
        searchFeaturedProduct()

        searchRef.current?.focus();

    };

    const printReceipt = () => {
        handlePrint();

    };

    return (
        <>
        <Toast ref={toast} position="top-center" />

        <div style={{ display: "none" }}><PosReceiptPrint ref={receiptRef} data={receiptData} /></div>

        <Layout menu="pos-cashier" breadcrumbs={false}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>

                {/* Open Session */}
                <Dialog
                    header="Open POS Session"
                    visible={showStartSession}
                    style={{ width: "420px" }}
                    closable={false}
                    draggable={false}
                    modal
                >
                    <div className="form-group">
                        <label>Terminal</label>

                        <Dropdown
                            value={terminalId}
                            options={terminals}
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select Terminal"
                            className="w-100"
                            onChange={(e)=>setTerminalId(e.value)}
                            appendTo="self"
                        />

                    </div>

                    <div className="form-group mt-3">
                        <label>Opening Cash</label>
                        <CurrencyInput
                            value={openingCash}
                            onValueChange={(e) => setOpeningCash(e.value ?? 0)}
                        />
                    </div>

                    <div className="text-right mt-4">
                        <button
                            className="btn btn-secondary mr-2"
                            onClick={() => setShowStartSession(false)}
                        >
                            <i className='fas fa-times mr-2'></i>
                            Cancel
                        </button>
                        <button
                            className="btn btn-success"
                            onClick={startPosSession}
                        >
                            <i className="fas fa-play-circle mr-2"></i>
                            Proceed
                        </button>
                    </div>
                </Dialog>

                {/* Close Session */}
                <Dialog
                    header="Close POS Session"
                    visible={showCloseSession}
                    style={{ width: "400px" }}
                    modal
                    closable={false}
                    draggable={false}
                >
                    <div className="form-group">
                        <label className="font-weight-bold">
                            Actual Cash Count
                        </label>
                        <CurrencyInput
                            value={actualCash}
                            onValueChange={(e) => setActualCash(e.value ?? 0)}
                        />
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button
                            className="btn btn-secondary mr-2"
                            onClick={() => setShowCloseSession(false)}
                        >
                            <i className='fas fa-times mr-2'></i>
                            Cancel
                        </button>

                        <button
                            className="btn btn-danger"
                            onClick={closePosSession}
                        >
                            <i className="fas fa-door-closed mr-2"></i>
                            Close Session
                        </button>
                    </div>
                </Dialog>

                {/* Cash Movement */}
                <Dialog
                    header="Cash Movement"
                    visible={showMovement}
                    style={{ width: "450px" }}
                    modal
                    closable={false}
                    draggable={false}
                >
                    <div className="form-group">
                        <label>Movement Type</label>

                        <Dropdown
                            value={movement.movement_type}
                            options={movementTypes}
                            optionLabel="label"
                            optionValue="id"
                            className="w-100"
                            appendTo="self"
                            onChange={(e)=>{
                                setMovement(prev=>({
                                    ...prev,
                                    movement_type:e.value
                                }));
                            }}
                        />

                    </div>

                    <div className="form-group mt-3">
                        <label>
                            Amount
                        </label>
                        <CurrencyInput
                            value={movement.amount}
                            onValueChange={(e) =>
                                setMovement({
                                    ...movement,
                                    amount: e.value ?? 0
                                })
                            }
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>
                            Remarks
                        </label>
                        <InputTextarea
                            rows={3}
                            className="w-100"
                            value={movement.remarks}
                            onChange={(e)=>{
                                setMovement(prev=>({
                                    ...prev,
                                    remarks:e.target.value
                                }));
                            }}
                        />
                    </div>

                    <div className="text-right mt-4">
                        <button
                            className="btn btn-secondary mr-2"
                            onClick={()=>setShowMovement(false)}
                        >
                            <i className="fas fa-times mr-2"></i>
                            Cancel
                        </button>

                        <button
                            className="btn btn-warning"
                            onClick={saveMovement}
                        >
                            <i className="fas fa-save mr-2"></i>
                            Save Movement
                        </button>
                    </div>
                </Dialog>

                {/* Customer */}
                <Dialog
                    header="Customer Name"
                    visible={showCustomer}
                    style={{ width: "400px" }}
                    modal
                    closable={false}
                    draggable={false}
                >
                    <div className="form-group">
                        {/* <label className="font-weight-bold">
                            Name
                        </label> */}
                        <InputText
                            value={customerData.customer_name}
                            onChange={(e) => {
                                setCustomerData(prev => ({
                                        ...prev,
                                        'customer_name': e.target.value
                                    }))
                                }
                            }
                            placeholder="Customer Name"
                            className="w-100 mt-1"
                        />
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button
                            className="btn btn-primary"
                            onClick={() =>setShowCustomer(false)}
                        >
                            <i className="fas fa-check mr-2"></i>
                            Done
                        </button>
                    </div>
                
                </Dialog>

                {/* Payment Successful */}
                <Dialog
                    header="Payment Successful"
                    headerClassName="text-center"
                    visible={showReceiptDialog}
                    style={{ width: "420px" }}
                    closable={false}
                    draggable={false}
                    resizable={false}
                    footer={
                        <div className='text-center'>
                            <button
                                className="btn btn-primary mr-2"
                                onClick={handlePrint}
                            >
                                <i className='fas fa-print mr-2'></i>
                                Print Receipt
                            </button>

                            <button
                                className="btn btn-success"
                                onClick={startNewSale}
                            >
                                <i className='fas fa-plus mr-2'></i>
                                New Sale
                            </button>
                        </div>
                    }
                >

                    <div className="text-center">
                        <i
                            className="fas fa-check-circle text-success mb-3"
                            style={{ fontSize: 60 }}
                        />

                        {/* <h4>Payment Successful</h4> */}
                        <p className="mb-1">
                            Invoice No.
                        </p>
                        <h5>{receiptData?.invoice_no}</h5>

                        <small>
                            The transaction has been completed successfully.
                        </small>
                    </div>

                </Dialog>

                {!isPosActive && (
                    <div className="pos-overlay">

                        <div className="pos-overlay-content">

                            {/* <i className="fas fa-cash-register fa-4x text-danger mb-3"></i> */}
                            <div className='text-sm'>Powered By</div>
                            <img src={bentapro_logo} alt="BentaPro Logo" className='brand-logo' />

                            <h5 className="font-weight-bold">
                                POS Session Not Active
                            </h5>

                            <p className="text-muted mb-4">
                                Open a POS session before accepting sales.
                            </p>

                            <button
                                className="btn btn-success px-5"
                                onClick={() => setShowStartSession(true)}
                            >
                                <i className="fas fa-play-circle mr-2"></i>
                                Open Session
                            </button>

                        </div>

                    </div>

                )}

                <div className={`card card-darks card-outlines pos-card ${maximized ? "fullscreen" : ""}`}>

                    <div className="card-header">
                        <div className='d-flex align-items-center justify-content-between'>
                            <h3 className="card-title">
                                {/* <i className="fas fa-cash-register mr-2"></i>
                                BentaPro  */}
                                {/* <div className='d-flex align-items-center'>
                                    <img src={bentapro_horizontal_logo} alt="BentaPro Logo" className="mr-2" style={{width: '120px'}} />
                                    <small className='text-muted'>www.bentapro.com &#8286; v1.0</small>
                                </div> */}

                                <div className='d-flex text-sm mt-1'>
                                    <span><b>Terminal:</b> {session?.id ? `${session?.terminal_code} - ${session?.terminal_name}` : "--"}</span>
                                    <span className='mx-2'>&#8286;</span>
                                    <span><b>Session:</b> #{String(session?.id ?? 0).padStart(5, "0")}</span>
                                    <span className='mx-2'>&#8286;</span>
                                    <span><b>Cashier:</b> {session?.id ? session?.opened_by_name : '---'}</span>
                                    <span className='mx-2'>&#8286;</span>
                                    <span><b>Customer:</b> {customerData.customer_name ? customerData.customer_name : '---'}</span>
                                </div>
                            </h3>

                            <div className="card-tools">

                                {/* <Button 
                                    className='btn btn-outline-secondarys btn-sm ml-2'
                                    // style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                    onClick={(event) => menuRight.current.toggle(event)} 
                                    aria-controls="popup_menu_right"
                                    aria-haspopup
                                ><div className='d-flex'><BsThreeDotsVertical /></div></Button>  */}
                                {/* <Menu 
                                    model={actionItems} 
                                    popup ref={menuRight} 
                                    id="popup_menu_right" 
                                    popupAlignment={menuAlignment}
                                    appendTo="self"
                                /> */}

                                <button
                                    type='button'
                                    className='btn btn-tootle btn-primary btn-sm mr-2'
                                    onClick={()=> {
                                        setShowCustomer(true);
                                    }}
                                >
                                    <div className='d-flex'><PiUserSwitchBold size={23} className='mr-2'/> Customer</div>
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-tootle btn-warning btn-sm mr-2'
                                    onClick={()=> {
                                        setMovement({
                                            movement_type: "CASH_OUT",
                                            amount: 0,
                                            remarks: ""
                                        });
                                        setShowMovement(true);
                                    }}
                                >
                                    <i className="fas fa-exchange-alt mr-2 text-warnings"></i> Movement
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-tootle btn-danger btn-sm  mr-2'
                                    onClick={() => {
                                        setActualCash(0);
                                        setShowCloseSession(true);
                                    }}
                                >
                                    <i className="fas fa-door-closed mr-2 text-dangers"></i> Close
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-tool pr-0"
                                    onClick={() => setMaximized(!maximized)}
                                >
                                    <i className={`fas ${maximized ? "fa-compress" : "fa-expand"}`}></i>
                                </button>

                            </div>
                        </div>
                    </div>

                    <div className="card-body">

                        <div className="pos-layout">

                            {/* Products */}

                            <div className="products-container">

                                <div className="products-header">
                                    <IconField iconPosition="left" className="w-100">
                                        <InputIcon className="fas fa-search" />
                                        <InputText
                                            ref={searchRef}
                                            value={keyword}
                                            onChange={handleSearch}
                                            onKeyDown={handleKeyDown}
                                            placeholder="[F1] Scan barcode or search product..."
                                            className="w-100 p-inputtext-sm"
                                            autoFocus
                                        />
                                    </IconField>

                                    {
                                    categories.length > 0 && (
                                    <div className="mt-3">
                                        <button className={`btn ${selectedCategory === 0 ? "btn-primary" : "btn-outline-secondary"} btn-sm mr-2`} onClick={() => setSelectedCategory(0)}>
                                            All
                                        </button>
                                        {
                                            categories.map(data => (

                                            <button className={`btn ${selectedCategory === data.category_id ? "btn-primary" : "btn-outline-secondary"} btn-sm mr-2`} onClick={() => setSelectedCategory(Number(data.category_id))}>
                                                {data.category_name}
                                            </button>
                                            ))
                                        }
                                        {/* <button className="btn btn-outline-secondary btn-sm mr-2">
                                            Snacks
                                        </button>
                                        <button className="btn btn-outline-secondary btn-sm mr-2">
                                            Grocery
                                        </button> */}
                                    </div>
                                    )}

                                </div>

                                <div className="products-body">
                                    {/* Initial */}
                                    {keyword.trim().length < 2 && !hasFeaturedProducts && (
                                        <div className="empty-products">
                                            <i className="fas fa-search fa-3x text-muted mb-3"></i>
                                            <h5>Search Products</h5>
                                            <small className="text-muted">
                                                [F1] Scan barcode or type at least 2 characters.
                                            </small>
                                        </div>
                                    )}

                                    {/* Loading */}
                                    {
                                        keyword.trim().length >= 2 && 
                                        loadingProducts && (
                                        <div className="empty-products">
                                            <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                                            <h5>Searching...</h5>
                                        </div>
                                    )}

                                    {/* Empty */}
                                    {
                                        keyword.trim().length >= 2 &&
                                        !loadingProducts &&
                                        products.length === 0 && (

                                        <div className="empty-products">
                                            <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                                            <h5>No products found</h5>
                                            <small className="text-muted">
                                                Try another keyword.
                                            </small>
                                        </div>
                                    )}

                                    {/* Products */}
                                    {
                                        //keyword.trim().length >= 2 &&
                                        !loadingProducts &&
                                        products.length > 0 && (

                                        <div className="products-grid">

                                            {products
                                                .filter(product => {
                                                    if (
                                                        selectedCategory !== 0 &&
                                                        product.category_id !== selectedCategory
                                                    ) {
                                                        return false;
                                                    }

                                                    if(!product.track_inventory) return true;

                                                    const cartItem = cart.find(
                                                        item => item.product_variant_id === product.product_variant_id
                                                    );

                                                    // Show product if it's not in the cart
                                                    if (!cartItem) {
                                                        return true;
                                                    }

                                                    // Hide product once maximum stock has been added
                                                    return cartItem.quantity < product.available_stock;
                                                })
                                                .map(product => (

                                                    <div
                                                        key={product.product_variant_id}
                                                        className={`product-tile ${
                                                            product.available_stock <= 0 && product.track_inventory == 1
                                                                ? "out-of-stock"
                                                                : ""
                                                        }`}
                                                        onClick={() => addToCart(product)}
                                                    >

                                                        {/* <img
                                                            src={
                                                                product.image ??
                                                                `https://placehold.co/150x150?text=${product.product_name}`
                                                            }
                                                            alt={product.product_name}
                                                        /> */}

                                                        <div className="product-name">
                                                            {product.product_name}
                                                        </div>

                                                        <div className="product-variant">
                                                            {product.product_variant_name !== 'Generic' ? `${product.product_variant_name}` : ''}
                                                        </div>

                                                        <div className="product-sku">
                                                            {product.product_code}
                                                        </div>

                                                        {Number(product.track_inventory) === 0 ? (
                                                            <div className="stock-label stock-available">
                                                                In Stock
                                                            </div>
                                                        ) : Number(product.available_stock) > 0 ? (
                                                            <div className="stock-label stock-available">
                                                                In Stock ({product.available_stock})
                                                            </div>
                                                        ) : (
                                                            <div className="stock-label stock-out">
                                                                Out of Stock
                                                            </div>
                                                        )}

                                                        <div className="product-price">
                                                            ₱{product.product_price}
                                                        </div>
                                                    </div>

                                                ))}

                                        </div>

                                    )}

                                </div>

                            </div>

                            {/* Right */}

                            <div className="right-panel px-1">

                                <div className="card card-successs card-outline flex-fill cart-card">

                                    {/* <div className="card-header font-weight-bold">
                                        CART
                                    </div> */}

                                    <div className="card-body p-0">

                                        <div className="cart-list">

                                            {cart.length === 0 && (

                                                <div className="text-center text-muted mt-5 empty-cart">

                                                    <i
                                                        className="fas fa-shopping-cart mb-3"
                                                        style={{ fontSize: 50 }}
                                                    />

                                                    <p>No items yet</p>

                                                </div>

                                            )}

                                            {cart.map(item => (

                                                <div
                                                    key={item.id}
                                                    className="cart-item"
                                                >

                                                    <div className="d-flex justify-content-between">

                                                        <strong>
                                                            {item.product_name} 
                                                            {item.product_variant_name !== 'Generic' ? ` (${item.product_variant_name})` : ''}
                                                        </strong>

                                                        <button
                                                            className="btn btn-xs btn-danger"
                                                            onClick={() => removeItem(item.product_variant_id)}
                                                        >

                                                            <i className="fas fa-trash"/>

                                                        </button>

                                                    </div>

                                                    <small className="text-muted">
                                                        {item.product_code}
                                                    </small>

                                                    <div className="d-flex justify-content-between align-items-center mt-2">

                                                        <div>

                                                            <button
                                                                className="btn btn-light btn-sm"
                                                                onClick={() => decreaseQty(item.product_variant_id)}
                                                            >
                                                                -
                                                            </button>

                                                            <span className="mx-3">
                                                                {item.quantity}
                                                            </span>

                                                            <button
                                                                className="btn btn-light btn-sm"
                                                                onClick={() => increaseQty(item.product_variant_id)}
                                                            >
                                                                +
                                                            </button>

                                                        </div>

                                                        <strong>
                                                            {/* ₱{(item.quantity * item.price).toFixed(2)} */}
                                                            ₱{helpers.formatAmount((item.quantity * item.product_price))}                                                         
                                                        </strong>

                                                    </div>

                                                </div>

                                            ))}

                                        </div>

                                    </div>

                                    <div className="card-footer py-2">

                                        <div className="d-flex justify-content-between">

                                            <span>{summary.totalItems > 1 ? 'Items' : 'Item'}</span>

                                            <strong>{summary.totalItems}</strong>

                                        </div>

                                        <div className="d-flex justify-content-between">

                                            <span>Subtotal</span>

                                            <strong>
                                                ₱{helpers.formatAmount(summary.subtotal)}
                                            </strong>

                                        </div>

                                    </div>
                                </div>

                                <div className="card card-warnings card-outlines payment-card">
                                    <div className="card-header">
                                        <div className="payment-total d-flex justify-content-between align-items-center">
                                            <p className='font-weight-bold mb-0'>Total Due</p>
                                            <h5 className='font-weight-bold mb-0'>₱{helpers.formatAmount(summary.total)}</h5>
                                        </div>

                                    </div>
                                    <div className="card-body">

                                        <div className="row mb-3">
                                            <div className="col-md-6 form-groups">
                                                <Dropdown value={paymentMethodId} options={paymentMethods} optionLabel="method_name" optionValue="id" onChange={(e) => setPaymentMethodId(e.value)} placeholder="Select Payment Method" className="w-100 p-inputtext-sm" disabled={!isPosActive} appendTo="self"/> 
                                            </div>
                                            <div className="col-md-6 form-groups">
                                                <InputText
                                                    value={paymentReferenceNo}
                                                    onChange={(e) => setPaymentReferenceNo(e.target.value)} 
                                                    placeholder="Reference No"
                                                    className="w-100 p-inputtext-sm"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 form-groups">

                                                <label className='text-small'>Cash Received</label>

                                                <input
                                                    type="number"
                                                    className="form-control text-right"
                                                    value={amountReceived}
                                                    onChange={(e)=>setAmountReceived(Number(e.target.value))}
                                                />

                                            </div>
                                            <div className="col-md-6 form-groups">
                                                <label>Change</label>
                                                <div className="change-box">
                                                    <strong>
                                                        ₱{change.toFixed(2)}
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>

                                        <button
                                            className="btn btn-success btn-block"
                                            disabled={amountReceived < summary.total || !cart.length}
                                            onClick={handleSubmit}
                                        >
                                            <i className="fas fa-check-circle mr-2"></i>
                                            Checkout [F2]
                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </Layout>
        </>
    )
}